import {
    getNotificationsList,
    deleteNotification
} from 'services/notificationService';
import { toast } from 'react-toastify';
import { processErrorResponse } from 'utils/errorHandler';
import { changeStatusForMany } from 'services/notificationService';

export const getNotifications = (params) => async (dispatch) => {
    if (!params.silent) {
        dispatch({ type: "GET_NOTIFICATIONS_LOADING" });
    }
    try {
        // Remove silent from query params
        const { silent, ...queryParams } = params;
        const query = queryParams ? `?${new URLSearchParams(queryParams).toString()}` : "";

        // Add silent header if silent is true
        const options = silent ? {
            headers: {
                'X-Silent-Request': 'true'
            }
        } : {};

        const data = await getNotificationsList(`/notifications${query}`, "GET", null, options);
        dispatch({ type: "GET_NOTIFICATIONS_SUCCESS", payload: data });
    } catch (error) {
        dispatch({ type: "GET_NOTIFICATIONS_FAILURE", payload: error.message });
        processErrorResponse(error);
    }
};

export const removeNotification = (body) => async (dispatch) => {
    dispatch({ type: 'NOTIFICATION_DELETE_REQUEST' });
    try {
        await deleteNotification('/notifications', body);
        dispatch({ type: 'NOTIFICATION_DELETE_SUCCESS', payload: body });
        toast.success("Notification deleted successfully!");
    } catch (error) {
        dispatch({ type: 'NOTIFICATION_DELETE_FAILURE', error: error.message });
        processErrorResponse(error);
        throw error;
    }
};

export const updateNotificationStatus = (payload, { silent = false } = {}) => async (dispatch) => {

    dispatch({ type: 'NOTIFICATION_UPDATE_STATUS_REQUEST' });

    try {
        await changeStatusForMany('/notifications/change-status', payload);

        dispatch({ type: 'NOTIFICATION_UPDATE_STATUS_SUCCESS' });
        if (!silent) {
            dispatch(getNotifications());
        }

    } catch (error) {
        dispatch({ type: 'NOTIFICATION_UPDATE_STATUS_FAILURE', error: error.message });
        processErrorResponse(error);
    }
};

